import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import AddCircleIcon from '@atlaskit/icon/glyph/add-circle';

const AddButton = ({
  content,
  isDisabled,
  onClick,
}) => (
  <Tooltip content={content} position="left">
    <Button
      appearance="subtle"
      iconBefore={<AddCircleIcon size="small" />}
      isDisabled={isDisabled}
      onClick={onClick}
      spacing="compact"
    />
  </Tooltip>
);

AddButton.propTypes = {
  content: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

AddButton.defaultProps = {
  isDisabled: false,
};

export default AddButton;
